import React, { useState, useRef, useEffect } from 'react';
import Helper from "../../helper";
import Appconfig from "../../config/config";
import axios from "axios";
import { toast } from "react-toastify";
import "../../App.css";
import Login from "../Login/Login";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';


const categories = [
  { name: 'Originals', key: 'originals' },
  { name: 'Crash Games', key: 'crash' },
  { name: 'Live Roulette', key: 'roulette' },
  { name: 'Live Casino', key: 'live' },
  // { name: 'Money Wheel', key: 'wheel' }
];

// Add a 'category' property to each game for filtering
const games = [
  {
    title: 'T20 - LotusPlus365',
    href: '/livegames/T20/FAWK/800011',
    src: 'https://img.jaipurapps.com/new-casino-img/Supernova/Teen-Patti-2020.webp',
    category: 'originals',
    provider_code: 'SN',
    game_code: 'TP20'
  },
  {
    title: 'Color Game - LotusPlus365',
    href: '/livegames/Color Game/FAWK/700158',
    src: 'https://img.jaipurapps.com/new-casino-img/jiligaming/Color-Game.webp',
    category: 'originals',
    provider_code: 'SN',
    game_code: 'VCG'
  },
  {
    title: 'Aviator',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://img.jaipurapps.com/new-casino-img/mac888/Crash.webp',
    category: 'originals',
    provider_code: 'SPB',
    game_code: 'aviator'
  },
  {
    title: '7up Down - LotusPlus365',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://img.jaipurapps.com/new-casino-img/royalgaming/7up-and-Down.webp',
    category: 'originals',
    provider_code: 'SN',
    game_code: 'VUD7'
  },
  {
    title: 'Mines - LotusPlus365',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://img.jaipurapps.com/new-casino-img/mac888/Mines.webp',
    category: 'originals',
    provider_code: 'SPB',
    game_code: 'mines'
  },
  {
    title: 'Aviator2 - LotusPlus365',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://img.jaipurapps.com/new-casino-img/smartsoft/balloon.webp',
    category: 'originals',
    provider_code: 'SMTSG',
    game_code: 'Balloon'
  },
  {
    title: 'Crash - LotusPlus365',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://img.jaipurapps.com/new-casino-img/mac888/Limbo.webp',
    category: 'originals',
    provider_code: 'SMTSG',
    game_code: 'TugOfWar'
  },
  {
    title: 'Aviator-original - LotusPlus365',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://luckmedia.link/spb_aviator/thumb_3_4_custom.webp',
    category: 'crash',
    provider_code: 'SPB',
    game_code: 'aviator'
  },
  {
    title: 'Jet-X - LotusPlus365',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://luckmedia.link/sms_jetx/thumb_3_4_custom.webp',
    category: 'crash',
    provider_code: 'SMTSG',
    game_code: 'JetX'
  },
  {
    title: 'Baloon - LotusPlus365',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://luckmedia.link/sms_baloon/thumb_3_4_custom.webp',
    category: 'crash',
    provider_code: 'SMTSG',
    game_code: 'Balloon'
  },
  {
    title: 'SpinX - LotusPlus365',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://luckmedia.link/sms_spinx/thumb_3_4_custom.webp',
    category: 'crash',
    provider_code: 'SMTSG',
    game_code: 'SpinX'

  },
  {
    title: 'FootballX - LotusPlus365',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://luckmedia.link/sms_footballx/thumb_3_4_custom.webp',
    category: 'crash',
    provider_code: 'SMTSG',
    game_code: 'FootballX'
  },
  {
    title: 'JetX3 - LotusPlus365',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://luckmedia.link/sms_jetx3/thumb_3_4_custom.webp',
    category: 'crash',
    provider_code: 'SMTSG',
    game_code: 'JetX3'
  },
  {
    title: 'CricketX - LotusPlus365',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://luckmedia.link/sms_cricketx/thumb_3_4_custom.webp',
    category: 'crash',
    provider_code: 'SMTSG',
    game_code: 'CricketX'
  },
  {
    title: 'Auto-Roulette',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://luckmedia.link/evo_autoroulette/thumb_3_4_custom.webp',
    category: 'roulette',
    provider_code: 'EZ',
    game_code: '5001'
  },
  {
    title: 'Instant-Roulette',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://luckmedia.link/evo_instant_roulette/thumb_3_4_custom.webp',
    category: 'roulette',
    provider_code: 'EZ',
    game_code: '507000'
  },
  {
    title: 'Lightining-Roulette',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://luckmedia.link/evo_lightning_roulette/thumb_3_4_custom.webp',
    category: 'roulette',
    provider_code: 'EZ',
    game_code: '1000'
  },
  {
    title: 'Immersive-roulette',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://luckmedia.link/evo_immersive_roulette/thumb_3_4_custom.webp',
    category: 'roulette',
    provider_code: 'EZ',
    game_code: '541000'
  },
  {
    title: 'Speed-roulette',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://luckmedia.link/evo_speed_roulette/thumb_3_4_custom.webp',
    category: 'roulette',
    provider_code: 'EZ',
    game_code: '221002'
  },
  {
    title: 'American-roulette',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://luckmedia.link/evo_american_roulette/thumb_3_4_custom.webp',
    category: 'roulette',
    provider_code: 'EZ',
    game_code: '411000'
  },
  {
    title: 'Double-ball-roulette',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://luckmedia.link/evo_double_ball_roulette/thumb_3_4_custom.webp',
    category: 'roulette',
    provider_code: 'EZ',
    game_code: '611007'
  },

  {
    title: 'Dream-Catcher',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://luckmedia.link/evo_first_person_dream_catcher/thumb_3_4_custom.webp',
    category: 'wheel'
  },
  {
    title: 'Imperial-Quest',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://luckmedia.link/evo_imperial_quest/thumb_3_4_custom.webp',
    category: 'wheel'
  },
  {
    title: 'BlackBeards',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://luckmedia.link/raw_blackbeards_superslice_rings/thumb_3_4_custom.webp',
    category: 'wheel'
  },
  {
    title: 'Lucky-Mcgees',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://luckmedia.link/raw_lucky_mcgees_superslice_swirl/thumb_3_4_custom.webp',
    category: 'wheel'
  },
  {
    title: 'Mad-Joker',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://luckmedia.link/raw_mad_joker_superslice_zones/thumb_3_4_custom.webp',
    category: 'wheel'
  },
  {
    title: 'The-Magnificient',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://luckmedia.link/raw_the_magnificent_superslice/thumb_3_4_custom.webp',
    category: 'wheel'
  },
  {
    title: 'Joker-And-Thief',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://luckmedia.link/raw_joker__the_thief/thumb_3_4_custom.webp',
    category: 'wheel'
  },
  {
    title: 'Boost-The-Wheel',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://luckmedia.link/mnc_boost_the_wheel/thumb_3_4_custom.webp',
    category: 'wheel'
  },
  {
    title: 'Wheel',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://luckmedia.link/iog_wheel/thumb_3_4_custom.webp',
    category: 'wheel'
  },
  {
    title: 'Andar-Bahar',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://img.jaipurapps.com/new-casino-img/Ezugi/Andar-Bahar.webp',
    category: 'live',
    provider_code: 'EZ',
    game_code: '228000'
  },
  {
    title: 'Lucky 7',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://img.jaipurapps.com/new-casino-img/Ezugi/Lucky-7.webp',
    category: 'live',
    provider_code: 'EZ',
    game_code: '228001'
  },
  {
    title: 'Dragon Tiger',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://img.jaipurapps.com/new-casino-img/Ezugi/dRAGON-tIGER.webp',
    category: 'live',
    provider_code: 'EZ',
    game_code: '150'
  },
  {
    title: 'Monopoly Live',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://img.jaipurapps.com/new-casino-img/evolutionlive/monopoly.webp',
    category: 'live',
    provider_code: 'EVZ',
    game_code: '1000096',
    type: 'EV'
  },
  {
    title: 'Crazy Time',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://img.jaipurapps.com/new-casino-img/evolutionlive/Crazy-Time-A.webp',
    category: 'live',
    provider_code: 'EVZ',
    game_code: '1000148',
    type: 'EV'
  },
  // {
  //   title: 'Deal Or No Deal',
  //   href: '/livegames/Aviator/FAWK/700168',
  //   src: 'https://img.jaipurapps.com/new-casino-img/evolutionlive/Deal-or-No-Deal.webp',
  //   category: 'live',
  //   provider_code: 'EVZ',
  //   game_code: '1000072',
  //   type: 'EV'
  // },
  {
    title: '1Tap Mines',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://img.jaipurapps.com/new-casino-img/turbo/1Tap-Mines.webp',
    category: 'live',
    provider_code: 'QT',
    game_code: 'TRB-1tapmines',
    // type: 'EV'
  },
  {
    title: '7up 7down',
    href: '/livegames/Aviator/FAWK/700168',
    src: 'https://img.jaipurapps.com/new-casino-img/jiligaming/7up7down.webp',
    category: 'live',
    provider_code: 'DC',
    game_code: '600064',
    // type: 'EV'
  },

  // Add more games with appropriate category keys...
];

const categoryColor = "#0c9971";

const Othercasino = () => {
  const [showLoginModel, setShowLoginModel] = useState(false);
  const [selected, setSelected] = useState('originals');
  const scrollRef = useRef(null);
  const userInfo = Helper();
  const [pendingGame, setPendingGame] = useState(null);
  const [loaderPercent, setLoaderPercent] = useState(0);
  const [showLoader, setShowLoader] = useState(false);
  const loaderIntervalRef = useRef(null);

  // Filter games by selected category
  const filteredGames = games.filter(game => game.category === selected);

  // Scroll handler
  const scrollByAmount = (amount) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: amount, behavior: 'smooth' });
    }
  };

  function startLoader() {
    setLoaderPercent(0);
    setShowLoader(true);
    if (loaderIntervalRef.current) clearInterval(loaderIntervalRef.current);
    loaderIntervalRef.current = setInterval(() => {
      setLoaderPercent(prev => {
        if (prev >= 90) return 90;
        return prev + 5;
      });
    }, 80);
  }

  function stopLoader() {
    if (loaderIntervalRef.current) clearInterval(loaderIntervalRef.current);
    setLoaderPercent(100);
    setTimeout(() => {
      setShowLoader(false);
      setLoaderPercent(0);
    }, 400);
  }

  function CreateAndLaunchWCOCasino(provider_code, game_code, type = null) {
    startLoader();

    const userData = {
      user_id: userInfo?._id,
      user_name: userInfo?.user_name,
      redirect_url: "https://daddyexch.live/",
      provider_code: provider_code,
      game_code: game_code,
      type: type,
    };

    var config = {
      method: "post",
      url: `${Appconfig.casinoUrl}wco/login`,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify(userData),
    };

    axios(config)
      .then(function (response) {
        let status = response.data.status?.code;
        if (status === "SUCCESS") {
          window.open(response.data.launchURL, "_self");
        } else if (status == "VALIDATION_ERROR" || status == "UNKNOWN_ERROR") {
          toast.error("Game Not Found.", { autoClose: 2000 });
        } else if (status == "AUTHENTICATION_FAILED") {
          toast.error(response.data.status?.message, { autoClose: 2000 });
        }
        stopLoader();
      })
      .catch(function (error) {
        stopLoader();
        console.log(error);
      });
  }

 // Launch pending game after login
  useEffect(() => {
    if (userInfo && userInfo._id && pendingGame) {
      CreateAndLaunchWCOCasino(pendingGame.provider_code, pendingGame.game_code, pendingGame.type, "casino");
      setPendingGame(null);
    }
  }, [userInfo, pendingGame]);

  useEffect(() => {
    return () => {
      if (loaderIntervalRef.current) clearInterval(loaderIntervalRef.current);
    };
  }, []);

  // Loader SVG ring calculation
  const radius = 45;
  const circumference = 2 * Math.PI * radius;
  const progress = loaderPercent / 100;
  const strokeDashoffset = circumference * (1 - progress);

  // function CreateAndLaunchWCOCasino(provider_code, game_code, type = null) {
  //   // Show SweetAlert first
  //   Swal.fire({
  //     icon: 'warning',
  //     title: 'Casino Limit Exceeded',
  //     text: 'Contact Upline for more information.',
  //     confirmButtonColor: '#0c9971',
  //     confirmButtonText: 'OK'
  //   }).then(() => {
  //     // After clicking OK, continue to loader and API request
  //     startLoader();

  //     const userData = {
  //       user_id: userInfo?._id,
  //       user_name: userInfo?.user_name,
  //       redirect_url: "https://daddyexch.live/",
  //       provider_code: provider_code,
  //       game_code: game_code,
  //       type: type,
  //     };

  //     var config = {
  //       method: "post",
  //       url: `${Appconfig.apiUrl}wco/login`,
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       data: JSON.stringify(userData),
  //     };

  //     axios(config)
  //       .then(function (response) {
  //         let status = response.data.status?.code;

  //         if (status === "SUCCESS") {
  //           window.open(response.data.launchURL, "_self");
  //         } else {
  //           Swal.fire({
  //             icon: 'error',
  //             title: 'Casino Error',
  //             text: 'Something went wrong.',
  //             confirmButtonColor: '#0c9971'
  //           });
  //         }

  //         stopLoader();
  //       })
  //       .catch(function (error) {
  //         stopLoader();
  //         Swal.fire({
  //           icon: 'error',
  //           title: 'Error Occurred',
  //           text: 'Please try again later.',
  //           confirmButtonColor: '#0c9971'
  //         });
  //         console.error(error);
  //       });
  //   });
  // }

  

 return (
    <div className="flex flex-col bg-bg_color_primary rounded-[10px] w-full divide-y divide-border_color_primary mt-1.5">
      {/* Loader HTML */}
      {showLoader && (
        <div className="preloader">
          <div className="loader-container">
            <svg className="progress-ring" width="100" height="100">
              <circle
                className="progress-ring-bg"
                cx="50"
                cy="50"
                r={radius}
                style={{ stroke: 'rgba(255,255,255,0.1)', strokeWidth: 2, fill: 'transparent' }}
              ></circle>
              <circle
                className="progress-ring-circle"
                cx="50"
                cy="50"
                r={radius}
                style={{
                  stroke: 'var(--color-accent-1)',
                  strokeWidth: 2,
                  fill: 'transparent',
                  strokeDasharray: circumference,
                  strokeDashoffset,
                  transition: 'stroke-dashoffset 0.3s linear'
                }}
              ></circle>
            </svg>
            <div className="loader-content">
              <div className="loading-stage">
                <div className="stage-current">Loading</div>
                <div className="stage-next">Ready</div>
              </div>
              <div className="percentage">{loaderPercent}</div>
            </div>
          </div>
          <div className="loader-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
          </div>
        </div>
      )}
      <div className="w-full flex flex-row justify-between px-0.5 pr-1">
        <div className="max-w-[83%] text-text_color_primary1 font-semibold capitalize cursor-pointer">
          <div className="flex items-center w-full justify-start overflow-scroll no-scrollbar scroll-smooth">
            {categories.map((cat) => (
              <div
                key={cat.key}
                className="flex items-center justify-start py-1.5 px-2 rounded-t-[6px] h-full relative"
                onClick={() => setSelected(cat.key)}
                style={{ cursor: "pointer" }}
              >
                <span
                  className={`text-sm capitalize whitespace-nowrap w-full text-center font-medium`}
                  style={{
                    color: selected === cat.key ? categoryColor : "var(--text-color-primary)",
                    background: selected === cat.key ? "none" : undefined
                  }}
                >
                  {cat.name}
                </span>
                <div
                  className="absolute bottom-0 left-0 right-0 w-full h-[2px] rounded"
                  style={{
                    background: selected === cat.key ? categoryColor : "transparent"
                  }}
                ></div>
              </div>
            ))}
          </div>
        </div>
        <div className="flex w-[108.75px] items-center justify-end gap-[5px]">
          <button
            className="carousel-nav-btn"
            type="button"
            onClick={() => scrollByAmount(-200)}
            aria-label="Scroll Left"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" strokeWidth="1.5" stroke="var(--icon-color-brand-secondary)" fill="none" strokeLinecap="round" strokeLinejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M15 6l-6 6l6 6" />
            </svg>
          </button>
          <button
            className="carousel-nav-btn"
            type="button"
            onClick={() => scrollByAmount(200)}
            aria-label="Scroll Right"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" strokeWidth="1.5" stroke="var(--icon-color-brand-secondary)" fill="none" strokeLinecap="round" strokeLinejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M9 6l6 6l-6 6" />
            </svg>
          </button>
        </div>
      </div>

      <div
        ref={scrollRef}
        className="flex overflow-x-scroll no-scrollbar scroll-smooth gap-x-1 p-2.5"
      >
       {filteredGames.map((game, index) => (
          <div
            key={index}
            onClick={() => {
              if (!userInfo || !userInfo._id) {
                setPendingGame(game); // Remember which game was clicked
                setShowLoginModel(true);
              } else if (game.provider_code && game.game_code) {
                CreateAndLaunchWCOCasino(game.provider_code, game.game_code, game.type, "casino");
              }
            }}
          >
            <div className="relative overflow-hidden min-w-[117px] w-[117px] sm:min-w-[140px] sm:w-[140px] md:min-w-[160px] md:w-[160px] aspect-[0.85] object-cover cursor-pointer rounded-md">
              <img
                src={game.src}
                alt={game.title}
                loading="lazy"
                className="w-full h-full active:scale-105 transition-all duration-300 ease-in-out hover:scale-105 aspect-[0.85]"
                title={game.title}
              />
            </div>
          </div>
        ))}
      </div>
      <Login
        showPopup={showLoginModel}
        togglePopup={() => setShowLoginModel(false)}
        // Pass other required props here
      />
    </div>
  );
};

export default Othercasino;